<script>
  import EditDialogFieldDataTable from "../EditDialogs/EditDialogFieldDataTable.vue";
  import {mapState} from "vuex";
  import _ from "lodash";

  export default {
    name: "CardTableTechMap",
    components: {EditDialogFieldDataTable},

    props: {
      data_table: {
        type: Array
      },
      semester: {
        type: String
      },
      edit_mode: {
        type: Boolean
      },
      alternative_view: {
        type: Boolean
      },
      areas_training:{
        type: Array
      },
      format_controls:{
        type: Array
      }
    },

    data: () => ({
      headers_table_tech_map: [
        {
          text: '№ раздела (модуля)',
          value: 'index_module',
          sortable: false,
          align: 'center',
          class: 'section-field'
        },
        {text: 'Название раздела/Темы лекций ', value: 'name', sortable: false, align: "start", filterable: false},
        {text: 'Лекция', value: 'types_lecture', align: "center", sortable: false, filterable: false},
        {
          text: 'Практическое занятие',
          value: 'types_practical_training',
          align: "center",
          sortable: false,
          filterable: false
        },
        {
          text: 'Лабораторная работа',
          value: 'types_laboratory_work',
          sortable: false,
          align: "center",
          filterable: false
        },
        {text: 'СРС', value: 'types_students_independent_work', sortable: false, align: "center", filterable: false},
        {text: 'Контроль', value: 'types_final_control', sortable: false, align: "center", filterable: false},
        {text: 'Действия', value: 'action', sortable: false, align: "center", filterable: false},
      ],
      menu_items: [
        {icon: "fa fa-trash", color: "red", name: "Удалить"},
      ],
    }),
    mounted() {},
    computed: {
      ...mapState({
        current_course: state => state.studyEstimationEuk.current_course,
        loading_update_course: state => state.studyEstimationEuk.loading_update_course,
        technical_map: state => state.studyEstEukTechMap.technical_map,
      }),
    },
    methods: {
      menuMethods(parent_module, child_module = null, item_name) {
        if (item_name === "Удалить") {
          this.deleteModule(parent_module, child_module)
        }
      },
      deleteModule(parent_module, child_module = null) {
        if (child_module) {
          let index_parent_module = _.findIndex(this.data_table, ['id', parent_module.id]);
          let index_child_module = _.findIndex(this.data_table[index_parent_module].items, ['id', child_module.id]);

          this.data_table[index_parent_module].items.splice(index_child_module, 1)
        } else {
          let index_parent_module = _.findIndex(this.data_table, ['id', parent_module.id]);

          this.data_table.splice(index_parent_module, 1)
        }
      },
      asyncCurrentTechMap(){
        let course_id = ''

        if (Object.keys(this.current_course).length > 0){
          course_id = this.current_course.course_id
        }
        else
        {
          course_id = this.technical_map.course_id
        }

        this.$emit('asyncCurrentTechMap',{
          course_id:  course_id,
          semester: this.semester,
          data_table: this.data_table,
          format_controls: this.format_controls
        })
      }
    }
  }
</script>

<template>
  <v-card class="overflow-hidden rounded-xl" outlined tile>
    <v-data-table
          :headers="headers_table_tech_map"
          :items="data_table"
          no-data-text="Данные курса отсутствуют"
          fixed-header
          mobile-breakpoint="0"
          hide-default-footer
          disable-pagination
      >
      <template v-slot:top>
        <div class="d-flex">
          <v-spacer/>
          <v-btn
              @click="asyncCurrentTechMap()"
              elevation="0"
              class="ma-2 white--text"
              :loading="loading_update_course"
              :disabled="loading_update_course"
              rounded
              small
              color="teal"
          >
            <v-icon left size="15px">
              fa fa-spinner
            </v-icon>
            <div
                class="text-subtitle-1"
            >
              moodle
            </div>
          </v-btn>
        </div>
      </template>
        <template v-slot:body="{ items, headers }">
          <tbody v-if="alternative_view">
          <template v-for="(parent_module, index_parent_module) in items">
            <tr :key="index_parent_module">
              <td :class="headers_table_tech_map[0].class" class="text-center">{{ index_parent_module + 1 }}</td>
              <template v-if="areas_training.includes(parent_module.name) || parent_module.name === '' || parent_module.name === null">
                <td :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
                <td v-for="(i, index) in 4" :key="index" :class="headers_table_tech_map[0].class"/>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[6].text"
                      :types_module="parent_module.types_final_control"
                      :types_module_flag="'types_final_control'"
                      @updateTypesModule="(prop) => (parent_module.types_final_control = prop.selected_types_module)"
                  />
                </td>
              </template>
              <template v-else>
                <td colspan="6" :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
                <td>
                  <div class="d-flex justify-center">
                    <v-menu
                        rounded="lg"
                        offset-y
                        left
                        origin="top right"
                        transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="!edit_mode"
                            x-small
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon
                              size="15px"
                          >
                            fa-ellipsis-v
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list class="ma-0">
                        <v-list-item
                            @click="menuMethods(parent_module, null, menu_item.name)"
                            :disabled="!edit_mode"
                            link
                            dense
                            class="px-0"
                            v-for="(menu_item, index) in menu_items" :key="index"
                        >
                          <v-list-item-avatar class="ma-0">
                            <v-icon small :color="menu_item.color">
                              {{ menu_item.icon }}
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title class="pr-2">{{ menu_item.name }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </td>
              </template>
            </tr>
            <tr v-for="(child_module, index_child_module) in parent_module.items">
              <td :class="headers_table_tech_map[0].class">{{ child_module.index_module }}</td>
              <td :class="headers_table_tech_map[0].class">{{ child_module.name }}</td>
              <td :class="headers_table_tech_map[0].class">
                <EditDialogFieldDataTable
                    :edit_mode="edit_mode"
                    :module="child_module"
                    :header_name="headers[2].text"
                    :types_module="child_module.types_lecture"
                    :types_module_flag="'types_lecture'"
                    @updateTypesModule="(prop) => (child_module.types_lecture = prop.selected_types_module)"
                />
              </td>
              <td :class="headers_table_tech_map[0].class">
                <EditDialogFieldDataTable
                    :edit_mode="edit_mode"
                    :module="child_module"
                    :header_name="headers[3].text"
                    :types_module="child_module.types_practical_training"
                    :types_module_flag="'types_practical_training'"
                    @updateTypesModule="(prop) => (child_module.types_practical_training = prop.selected_types_module)"
                />
              </td>
              <td :class="headers_table_tech_map[0].class">
                <EditDialogFieldDataTable
                    :edit_mode="edit_mode"
                    :module="child_module"
                    :header_name="headers[4].text"
                    :types_module="child_module.types_laboratory_work"
                    :types_module_flag="'types_laboratory_work'"
                    @updateTypesModule="(prop) => (child_module.types_laboratory_work = prop.selected_types_module)"
                />
              </td>
              <td :class="headers_table_tech_map[0].class">
                <EditDialogFieldDataTable
                    :edit_mode="edit_mode"
                    :module="child_module"
                    :header_name="headers[5].text"
                    :types_module="child_module.types_students_independent_work"
                    :types_module_flag="'types_students_independent_work'"
                    @updateTypesModule="(prop) => (child_module.types_students_independent_work = prop.selected_types_module)"
                />
              </td>
              <td :class="headers_table_tech_map[0].class">
                <EditDialogFieldDataTable
                    :edit_mode="edit_mode"
                    :module="child_module"
                    :header_name="headers[6].text"
                    :types_module="child_module.types_final_control"
                    :types_module_flag="'types_final_control'"
                    @updateTypesModule="(prop) => (child_module.types_final_control = prop.selected_types_module)"
                />
              </td>
              <td>
                <div class="d-flex justify-center">
                  <v-menu
                      rounded="lg"
                      offset-y
                      left
                      origin="top right"
                      transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          :disabled="!edit_mode"
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon
                            size="15px"
                        >
                          fa-ellipsis-v
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list class="ma-0">
                      <v-list-item
                          @click="menuMethods(parent_module, child_module, menu_item.name)"
                          link
                          dense
                          class="px-0"
                          v-for="(menu_item, index) in menu_items" :key="index"
                      >
                        <v-list-item-avatar class="ma-0">
                          <v-icon class="d-flex align-center" small :color="menu_item.color">
                            {{ menu_item.icon }}
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title class="pr-2">{{ menu_item.name }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
          <tbody v-else>
          <template v-for="(parent_module, index_parent_module) in items">
            <tr :key="index_parent_module">
              <td :class="headers_table_tech_map[0].class" class="text-center">{{ index_parent_module + 1 }}</td>
              <template v-if="areas_training.includes(parent_module.name) || parent_module.name === '' || parent_module.name === null">
                <td :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
                <td v-for="(i, index) in 4" :key="index" :class="headers_table_tech_map[0].class"/>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[6].text"
                      :types_module="parent_module.types_final_control"
                      :types_module_flag="'types_final_control'"
                      @updateTypesModule="(prop) => (parent_module.types_final_control = prop.selected_types_module)"
                  />
                </td>
              </template>
              <template v-else>
                <td :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[2].text"
                      :types_module="parent_module.types_lecture"
                      :types_module_flag="'types_lecture'"
                      @updateTypesModule="(prop) => (parent_module.types_lecture = prop.selected_types_module)"
                  />
                </td>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[3].text"
                      :types_module="parent_module.types_practical_training"
                      :types_module_flag="'types_practical_training'"
                      @updateTypesModule="(prop) => (parent_module.types_practical_training = prop.selected_types_module)"
                  />
                </td>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[4].text"
                      :types_module="parent_module.types_laboratory_work"
                      :types_module_flag="'types_laboratory_work'"
                      @updateTypesModule="(prop) => (parent_module.types_laboratory_work = prop.selected_types_module)"
                  />
                </td>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[5].text"
                      :types_module="parent_module.types_students_independent_work"
                      :types_module_flag="'types_students_independent_work'"
                      @updateTypesModule="(prop) => (parent_module.types_students_independent_work = prop.selected_types_module)"
                  />
                </td>
                <td :class="headers_table_tech_map[0].class">
                  <EditDialogFieldDataTable
                      :edit_mode="edit_mode"
                      :module="parent_module"
                      :header_name="headers[6].text"
                      :types_module="parent_module.types_final_control"
                      :types_module_flag="'types_final_control'"
                      @updateTypesModule="(prop) => (parent_module.types_final_control = prop.selected_types_module)"
                  />
                </td>
                <td>
                  <div class="d-flex justify-center">
                    <v-menu
                        rounded="lg"
                        offset-y
                        left
                        origin="top right"
                        transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="!edit_mode"
                            x-small
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon
                              size="15px"
                          >
                            fa-ellipsis-v
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list class="ma-0">
                        <v-list-item
                            @click="menuMethods(parent_module, null, menu_item.name)"
                            :disabled="!edit_mode"
                            link
                            dense
                            class="px-0"
                            v-for="(menu_item, index) in menu_items" :key="index"
                        >
                          <v-list-item-avatar class="ma-0">
                            <v-icon small :color="menu_item.color">
                              {{ menu_item.icon }}
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title class="pr-2">{{ menu_item.name }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </td>
              </template>
            </tr>
          </template>
          </tbody>
        </template>
      </v-data-table>
  </v-card>
</template>

<style scoped>

.section-field {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

</style>